export const BANK_ACCOUNT_LIST = "bank_account_list";
export const BANK_ACCOUNT_LIST_SUCCESSFULL = "bank_account_list_successfull";
export const CREATE_BANK_ACCOUNT = "create_bank_account";
export const CREATE_BANK_ACCOUNT_SUCCESSFULL = "create_bank_account_successfull";
export const UPDATE_BANK_ACCOUNT = "update_bank_account";
export const UPDATE_BANK_ACCOUNT_SUCCESSFULL = "update_bank_account_successfull";
export const API_ERRORS = 'api_failed';